import axios, {AxiosRequestConfig} from 'axios';
import {useAuthStore} from "../store/auth.store";
import {useNavigate} from "react-router";
import {useEffect} from "react";
const host = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: host,
    paramsSerializer: params => {
        return Object.keys(params)
            .map(key => {
                return Array.isArray(params[key])
                    ? params[key].map((value:string) => `${key}=${encodeURIComponent(value)}`).join('&')
                    : `${key}=${encodeURIComponent(params[key])}`;
            })
            .join('&');
    }
});

export const useSetupInterceptors = () => {
    const navigate = useNavigate();
    const authStore = useAuthStore();

    useEffect(() => {
        const interceptor = api.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response && error.response.status === 401) {
                    authStore.logout(navigate);
                    authStore.setShowLogin(true);
                }
                if(error.response && error.response.data.message) {
                    error.message = error.response.data.message;
                }
                return Promise.reject(error);
            }
        );

        // Cleanup function to eject the interceptor when the component unmounts
        return () => {
            api.interceptors.response.eject(interceptor);
        };
    }, [authStore, navigate]); // Dependencies

}

export function doGet<T>(path:string, config?:AxiosRequestConfig) {
    return api.get<T>(host + path, updateConfig(config))
}
export function doPost<T>(path:string, data?:any, config?:AxiosRequestConfig) {
    return api.post<T>(host + path, data, updateConfig(config))
}
export function doPut<T>(path:string, data?:any, config?:AxiosRequestConfig) {
    return api.put<T>(host + path, data, updateConfig(config))
}
export function doPatch<T>(path:string, data:any, config?:AxiosRequestConfig) {
    return api.patch<T>(host + path, data, updateConfig(config))
}
export function doDelete<T>(path:string, config?:AxiosRequestConfig) {
    return api.delete<T>(host + path, updateConfig(config))
}

export function sanitizeFilterObject<T>(object:T) {
    for(let k in object) {
        if(!object[k] && object[k] !== 0 && object[k] !== false) {
            delete(object[k]);
        }
    }
    //@ts-ignore
    if(object.sortKey && object.sortOrder) {
        //@ts-ignore
        object.sort = object.sortKey + ',' + object.sortOrder
        //@ts-ignore
        delete (object.sortKey);
        //@ts-ignore
        delete (object.sortOrder);
    }
    return object;
}


function updateConfig(config?:AxiosRequestConfig):AxiosRequestConfig|undefined {
    const jwtStr = localStorage.getItem("realt_jwt");
    const header = jwtStr ? "Bearer " + jwtStr : undefined;
    if(!config) {
        config = {};
    }
    if(config.headers) {
        config.headers['Authorization'] = header;
    } else {
        config.headers = {'Authorization': header}
    }
    return config;
}

